<template>
  <div class="content-page real-time-info">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addNews">新建资讯</el-button>
        </div>
        <div class="header-right">
          <el-select
            popper-class="screen-select"
            v-model="newsModulesId"
            size="small"
            placeholder="请选择分类"
            clearable
          >
            <el-option
              v-for="item in newsModulesList"
              :key="item.id"
              :label="item.modulesName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="newsList" style="width: 100%">
            <el-table-column label="资讯标题">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.newsTitle }}</div>
              </template>
            </el-table-column>
            <el-table-column label="分类">
              <template slot-scope="scope">
                <div>{{ scope.row.newsModulesName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="right">
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button
                    size="small"
                    type="primary"
                    @click="editNews(scope.row)"
                    plain
                    >编辑</el-button
                  >
                  <el-button size="small" type="danger" @click="del(scope.row)" plain
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogBindNewsVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      @close="resetForm"
    >
      <div slot="title" class="dialog-title">
        {{ newsForm.shopId ? "编辑资讯" : "新建资讯" }}
      </div>
      <el-form
        :model="newsForm"
        :rules="rules"
        ref="newsForm"
        label-width="88px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
        :validate-on-rule-change="false"
      >
        <div>
          <el-form-item label="资讯标题" prop="newsTitle">
            <el-input
              v-model="newsForm.newsTitle"
              placeholder="请填写资讯标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="分类" prop="newsModulesId">
            <el-select
              popper-class="screen-select"
              v-model="newsForm.newsModulesId"
              size="small"
              placeholder="请选择分类"
              clearable
            >
              <el-option
                v-for="item in createModulesList"
                :key="item.id"
                :label="item.modulesName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序" prop="indexNo">
            <el-input
              v-model="newsForm.indexNo"
              @input.native="inputChangeLimitNumber($event)"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="展示图" prop="newsImage">
            <div>
              <el-upload
                :disabled="uploadDisabled"
                action="/ImageServer/YmUpload_image"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'newsImage');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'newsImage');
                  }
                "
                :before-upload="beforeImgUpload"
                :file-list="newsImage"
                :on-exceed="limitTip"
                :limit="1"
              >
                <div
                  style="width: 148px; height: 148px; position: absolute"
                  @click="show_uploadDialog(1, 'newsImage')"
                ></div>
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="置顶">
            <el-radio-group v-model="newsForm.isTop">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="推荐">
            <el-radio-group v-model="newsForm.isRecommended">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="显示">
            <el-radio-group v-model="newsForm.isEnable">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="详情" prop="newsContent">
            <quill-editor
              class="editor"
              v-model="newsForm.newsContent"
              ref="myQuillEditor"
              :options="editorOption"
              @change="onEditorChange($event)"
            />
            <input
              type="file"
              hidden
              accept=".jpg,.png"
              ref="fileBtn"
              @change="handleUpload"
            />
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('newsForm')" :loading="isSubmit">
          {{ newsForm.shopId ? "编辑" : "立即创建" }}</el-button
        >
        <el-button @click="dialogBindNewsVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <uploadImgComponent
      :isshow_uploadDialog="isshow_uploadDialog"
      @onClose="close_uploadDialog"
      @getChoose_ImgUrl="getChoose_ImgUrl"
      ref="childRef"
      :ImgLimits="ImgLimits"
      :uploadName="uploadName"
    ></uploadImgComponent>
  </div>
</template>

<script>
import {
  plusNews,
  getNewsList,
  modifyNews,
  deleteNews,
  uploadImg,
  getNewsModulesList,
} from "@/api";
import uploadImgComponent from "@/components/uploadImg";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { mapState } from "vuex";
export default {
  data() {
    return {
      newsList: [],
      isSubmit: false,
      pageNo: 1,
      pageSize: 5,
      pageCount: 0,
      dialogBindNewsVisible: false,
      dialogImageUrl: "",
      dialogVisible: false,
      newsForm: {
        newsImage: "",
        newsTitle: "",
        newsModulesId: "",
        shopAddress: "",
        newsContent: "",
        isRecommended: 1,
        isEnable: 1,
        isTop: 1,
      },
      rules: {
        newsImage: [
          {
            required: true,
            message: "请上传资讯展示图",
            trigger: "blur",
          },
        ],
        newsTitle: [
          {
            required: true,
            message: "请填写资讯标题",
            trigger: "blur",
          },
        ],
        newsContent: [
          {
            required: true,
            message: "请填写详情",
            trigger: "blur",
          },
        ],
        newsModulesId: [
          {
            required: true,
            message: "请选择分类",
            trigger: "blur",
          },
        ],
      },
      isshow_uploadDialog: false,
      uploadDisabled: false,
      ImgLimits: 1,
      uploadName: "",
      newsImage: [],
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["image"],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],

            ["clean"],
          ],
        },
        placeholder: "请填写详情",
      },
      newsModulesList: [],
      createModulesList: [],
      newsModulesId: "",
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  watch: {
    newsModulesId() {
      this.pageNo = 1;
      this.getNewsList();
    },
    dialogBindNewsVisible(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.myQuillEditor) {
            this.$refs.myQuillEditor.quill
              .getModule("toolbar")
              .addHandler("image", this.imgHandler);
          }
        });
      }
    },
  },
  components: {
    uploadImgComponent,
    quillEditor,
  },
  mounted() {
    this.getPageData();
    this.getNewsModulesList();
    this.getCreateModulesList();
  },
  methods: {
    getPageData(type = "") {
      if (type == "create") {
        this.pageNo = Math.ceil((this.pageCount + 1) / this.pageSize);
      }
      this.getNewsList();
    },
    imgHandler(state) {
      if (state) {
        this.$refs.fileBtn.click();
      }
    },
    getNewsList() {
      getNewsList({
        newsModulesId: this.newsModulesId,
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.code == 1) {
          this.newsList = res.data.list;
          this.pageCount = res.data.totalCount;
        } else {
          this.newsList = [];
          this.pageCount = 0;
        }
      });
    },
    getNewsModulesList() {
      getNewsModulesList().then((res) => {
        if (res.code == 1) {
          this.newsModulesList = res.data;
        }
      });
    },
    getCreateModulesList() {
      getNewsModulesList({
        isEnable: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.createModulesList = res.data;
        }
      });
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getPageData();
    },
    info(index) {},
    addNews() {
      let newsForm = JSON.parse(JSON.stringify(this.newsForm));
      newsForm.newsTitle = "";
      newsForm.shopAddress = "";
      this.newsForm = newsForm;
      this.dialogBindNewsVisible = true;
    },
    editNews(item) {
      let newsForm = JSON.parse(JSON.stringify(item));
      this.newsImage = newsForm.newsImage.length ? [{ url: newsForm.newsImage }] : [];
      this.newsForm = newsForm;
      this.dialogBindNewsVisible = true;
      //富文本编辑器神坑处理
      this.$nextTick(() => {
        this.$refs.myQuillEditor.quill.enable(true);
        this.$refs.myQuillEditor.quill.blur();
      });
    },
    getChoose_ImgUrl(val, name) {
      console.log(val, name);
      if (val.length > 0) {
        this.isshow_uploadDialog = false;
        this.uploadDisabled = false;
        val.forEach((item) => {
          if (name == "shopImages") {
            if (this.newsForm[name].length) {
              this.newsForm[name] += `,${item.image}`;
            } else {
              this.newsForm[name] = item.image;
            }
            this.shopImages.push({ name: "", url: item.image });
            return;
          }
          this.newsForm[name] = item.image;
          switch (name) {
            case "newsImage":
              this.newsImage = [];
              this.newsImage.push({ name: "", url: item.image });
              break;
            case "shopFaceImage":
              this.shopFaceImage = [];
              this.shopFaceImage.push({ name: "", url: item.image });
              break;
            case "bannerImage":
              this.bannerImage = [];
              this.bannerImage.push({ name: "", url: item.image });
              break;
            case "indexBackgroundImage":
              this.indexBackgroundImage = [];
              this.indexBackgroundImage.push({ name: "", url: item.image });
              break;
            default:
              console.log("111");
          }
        });
      }
    },
    close_uploadDialog() {
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
    },
    show_uploadDialog(val, name) {
      console.log(val, name);
      this.ImgLimits = val;
      this.uploadName = name;
      this.isshow_uploadDialog = true;
      this.uploadDisabled = true;
      this.$refs.childRef.rSelect = []; //  每次打开清除上一次的选择
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeImgUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isLt3M;
    },
    handleSuccess(item, name) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          if (name == "shopImages") {
            if (this.newsForm[name].length) {
              this.newsForm[name] += `,${res.data.url}`;
            } else {
              this.newsForm[name] = res.data.url;
            }
            return;
          }
          this.newsForm[name] = res.data.url;
        }
      });
    },
    submitForm(formName, cb) {
      console.log(this.newsForm, "newsForm");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let newsForm = JSON.parse(JSON.stringify(this.newsForm));
          newsForm.newsId = newsForm.id;
          if (newsForm.newsId) {
            modifyNews(newsForm).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "编辑成功",
                  type: "success",
                  duration: 2000,
                });
                this.dialogBindNewsVisible = false;
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "warning",
                  duration: 2000,
                });
              }
            });
          } else {
            plusNews(newsForm).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "保存成功",
                  type: "success",
                  duration: 2000,
                });
                this.dialogBindNewsVisible = false;
                this.getPageData("create");
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "warning",
                  duration: 2000,
                });
              }
            });
          }
        } else {
          this.$notify({
            title: "提示",
            message: "表单未完善，请检查资讯设置",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    limitTip(files, fileList) {
      this.$notify({
        title: "警告",
        message: "只能上传一张图片，请删除图片后再上传",
        type: "warning",
        duration: 6000,
      });
    },
    beforeRemove(file, fileList) {},
    saveStationAddress() {
      this.dialogMapVisible = false;
    },
    resetForm() {
      (this.newsForm = {
        newsImage: "",
        newsTitle: "",
        newsModulesId: "",
        shopAddress: "",
        newsContent: "",
        isRecommended: 1,
        isEnable: 1,
        isTop: 1,
      }),
        (this.newsImage = []);
      this.$refs.newsForm.resetFields();
    },
    del(item) {
      this.$msgbox({
        title: "消息",
        message: `是否删除，删除后将无法恢复！`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            deleteNews({
              newsId: item.id,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "删除成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
            done();
          } else {
            done();
          }
        },
      }).then((action) => {});
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
    },
    handleUpload(e) {
      const file = e.target.files;
      if (!file) {
        return;
      }
      let imgUploadForm = new FormData();
      let sessionId = localStorage.getItem("sessionId");
      let userId = localStorage.getItem("userId");
      imgUploadForm.append("file", file[0]);
      // imgUploadForm.append("fileContentType", file.file.type);
      // imgUploadForm.append("fileFileName", file.file.name);
      // imgUploadForm.append("isCompre", 1);
      // imgUploadForm.append("isCutImage", 1);
      imgUploadForm.append("userId", userId);
      imgUploadForm.append("sessionId", sessionId);
      uploadImg(imgUploadForm).then((res) => {
        console.log(res, 789);
        if (res.code == 1) {
          let selection = this.$refs.myQuillEditor.quill.getSelection();
          //这里就是返回的图片地址，如果接口返回的不是可以访问的地址，要自己拼接
          let imgUrl = res.data.url;
          //获取quill的光标，插入图片
          this.$refs.myQuillEditor.quill.insertEmbed(
            selection != null ? selection.index : 0,
            "image",
            imgUrl
          );
          //插入完成后，光标往后移动一位
          this.$refs.myQuillEditor.quill.setSelection(selection.index + 1);
        }
      });
    },
    inputChangeLimitNumber(e) {
      e.target.value = e.target.value.replace(/[^\d]/g, "");
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .list {
    width: 100%;
    padding: 0 20px;
  }
}
.map {
  width: 100%;
  height: 400px;
  　　/deep/ .anchorBL {
    display: none;
  }
}
.popup-container {
  text-align: center;
  padding-bottom: 10px;
  .qrcode {
    display: block;
    margin: 10px;
  }
}
.demo-ruleForm {
  height: 500px;
  overflow: auto;
}
</style>

<style lang="less">
.real-time-info {
  .quill-editor {
    line-height: 1;
    .ql-container {
      height: 360px;
    }
  }
}
</style>
